module.exports = __webpack_public_path__ + "static/media/bekescsaba_marker.4083b0b2.svg";